export const designationOptions = [
  { value: 'Owner', label: 'Owner' },
  { value: 'Client', label: 'Client' },
  { value: 'End User', label: 'End User' }
];
